// Author Eric
// Date 2021-04-12 12:19:42

import * as model from "@/model/sithMes/mst/SithMesMstLocalStorageModel.js";
import { newEntityStoreHelper } from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesMstLocalStorage(), newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_MST_URL,
    })
    // .withActions({
    //     retrieveForSelect(context) {
    //         let data = new FormData();
    //         data.append('parentIdFilter', '20313');
    //         context.dispatch("api/post", {
    //             url: process.env.VUE_APP_SITHMES_MST_URL + "/sithMesMstLocation/findByFilter",
    //             data: { 'parentIdFilter': '20313' }
    //         }, { root: true })
    //             .then(function (data) {
    //                 context.commit("sithMesMstLocation/setSelectRows", data.data.list, { root: true })
    //                 var result = data.data.list.map(x => context.state.selectRowsToItems(x))
    //                 context.commit("sithMesMstLocation/setSelectItems", result, { root: true })
    //                 // var result = data.map(x => { return { value: x.id, text: x.name } })
    //                 // context.commit("sithMesMstLocalStorage/setSelectItems", result, { root: true })
    //             })
    //     }
    // })
    .buildStore()
